import React, { useState, useEffect } from 'react';
import './login.css';
import { EyeSlash, Eye } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import { branchLogin } from '../../redux/actions/action-creator';

const initialState = {
    username: '',
    password: '',
    customer_code: '',
};

function Branch_Login() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { userData } = useSelector(state => state.auth);

    const [state, setState] = useState(initialState);
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);

    // If already logged in as branch, go to home
    useEffect(() => {
        if (userData?.login_type === 'branch' && userData?.company_id) {
            navigate('/');
        }
    }, [userData, navigate]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setState(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const { username, password, customer_code } = state;

        if (!username.trim() || !password.trim() || !customer_code.trim()) {
            toast.error('All fields are required.', { position: 'top-center', autoClose: 1800 });
            return;
        }

        setLoading(true);
        dispatch(branchLogin({ username, password, customer_code }))
            .then(() => {
                toast.success('Login successful!', { position: 'top-center', autoClose: 1000 });
                setTimeout(() => navigate('/'), 1000);
            })
            .catch(err => {
                toast.error(err?.message || 'Invalid credentials. Try again.', { position: 'top-center', autoClose: 2000 });
                setLoading(false);
            });
    };

    return (
        <div className='container-fluid' id='login-container'>
            <ToastContainer position="top-center" autoClose={1500} />
            <div className='row justify-content-center align-items-center' id='row'>
                {/* Left Side */}
                <div className='col-lg-6 d-none d-lg-block'>
                    <h1 className='text-primary' style={{ textAlign: 'left' }} id='man-heading'>
                        <b>eBalance Branch Login</b>
                    </h1>
                    <h5 style={{ textAlign: 'left', color: '#555', fontWeight: 400, lineHeight: 1.6 }}>
                        Login with your branch credentials to access data limited to your assigned godowns.
                    </h5>
                </div>

                {/* Right Side — Login Card */}
                <div className='col-lg-4 col-md-6 p-4'>
                    <div className='shadow rounded p-4' id='card'>
                        <h5 style={{ textAlign: 'center', marginBottom: 20, fontWeight: 700, color: '#2c3e50' }}>
                            Branch Login
                        </h5>

                        <form method='post' autoComplete='off' onSubmit={handleSubmit}>
                            {/* Customer Code */}
                            <div className="input-group input-group-md mb-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    autoComplete="off"
                                    placeholder="Company Code"
                                    name='customer_code'
                                    value={state.customer_code}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Username */}
                            <div className="input-group input-group-md mb-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    autoComplete="off"
                                    placeholder="Branch Username"
                                    name='username'
                                    value={state.username}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Password */}
                            <div className="input-group input-group-md mb-3">
                                <input
                                    type={visible ? 'text' : 'password'}
                                    className="form-control"
                                    autoComplete="off"
                                    placeholder="Password"
                                    name='password'
                                    value={state.password}
                                    onChange={handleChange}
                                />
                                <span className='input_icon-wrapper'>
                                    {visible
                                        ? <Eye className='input_icon' onClick={() => setVisible(false)} />
                                        : <EyeSlash className='input_icon' onClick={() => setVisible(true)} />
                                    }
                                </span>
                            </div>

                            {/* Login Button */}
                            <div className='input-group input-group-md mb-2'>
                                <button
                                    type="submit"
                                    disabled={loading}
                                    style={{ width: '100%' }}
                                    className="btn btn-primary"
                                >
                                    {loading ? 'Logging in...' : 'Login'}
                                </button>
                            </div>

                            {/* Info */}
                            <p style={{ textAlign: 'center', fontSize: '0.8rem', color: '#888', marginTop: 8 }}>
                                Branch users can only access their assigned godowns.
                            </p>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Branch_Login;
